import { Switch as MuiSwitch, styled } from "@mui/material";

export const Switch = styled(MuiSwitch)(() => ({
  overflow: "visible",
  padding: "0",
  height: "40px",
  width: "111px",
  "& .MuiSwitch-track": {
    borderRadius: "100px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#000000 ",
    opacity: 1,

    position: "relative",
    "&::before, &::after": {
      position: "absolute",
      fontFamily: "Segoe UI",
      fontSize: "26px",
      fontWeight: 600,
    },
    "&::before": {
      content: '"YES"',
      color: "#fff",
      left: "15px",
      opacity: 0,
    },
    "&::after": {
      content: '"NO"',
      color: "#fff",
      right: "20px",
      opacity: 1,
    },
  },
  "& .MuiSwitch-thumb": {
    width: "34px",
    height: "34px",
    background: "#fff",
    padding: "0",
    margin: "3px 4px",
    position: "relative",
  },

  "& .MuiSwitch-switchBase": {
    padding: "0px ",
    "&.Mui-checked": {
      transform: "translateX(69px)",
      "& + .MuiSwitch-track": {
        opacity: 1,
        "&::before": {
          opacity: 1,
        },
        "&::after": {
          opacity: 0,
        },
        backgroundColor: "#669BBC",
      },
    },
  },
}));
